exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".se--card-base {\n  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.05);\n  border-radius: 6px;\n}\n", ""]);

